module.exports = __webpack_public_path__ + "img/simple4.e4182536.png";